





































import ResourceItemTable from "@/components/resource/ResourceItemTable.vue";
import Vue, { CreateElement } from "vue";
import { createComponent } from "@vue/composition-api";
import {
  brandResource,
  languageResource,
  asortymentResource,
} from "@megarax/client/src/resources/plm";
import ResourceTableColumn from "@/components/ResourceTableColumn.vue";

export default createComponent({
  components: {
    ResourceItemTable,

    ResourceTableColumn,
  },
  setup(props, ctx) {
    return {
      resource: asortymentResource,
      brandResource,
      languageResource,
    };
  },
});
